<template>
  <div class="warpper">
    <div class="container">
      <crumb />
      <div class="lg">
        <order-menu />
        <div class="pay_con">
          <div class="side">
            <div class="collec_state">
              <div class="th1 cen">订单信息</div>
            </div>
            <ul class="collec_text">
              <li class="tx1">
                <div class="label">收货地址：</div>
                <div class="text">
                  huang拾柒，13160652175，广东省 中山市 坦洲镇 十四村芳草街
                  一巷5号2楼203
                </div>
              </li>
              <li class="tx1">
                <div class="label">订 单 号：</div>
                <div class="text">210909095300126574</div>
              </li>
              <li class="tx1">
                <div class="label">下单时间：</div>
                <div class="text">2021.09.09 09:04:21</div>
              </li>
              <li class="tx1">
                <div class="label">订单状态：</div>
                <div class="red">待付款</div>
              </li>
              <li class="tx1">
                <div class="label">备 注：</div>
                <div class="text">
                  您好！请给我发邮政快递，谢谢！
                </div>
              </li>
            </ul>
          </div>
          <div class="side">
            <div class="collec_state">
              <div class="pay1">订单信息</div>
              <div class="pay2">单价</div>
              <div class="pay3">数量</div>
              <div class="pay4">金额</div>
            </div>
            <ul class="pay_body" v-for="(item, index) in 10" :key="index">
              <li class="td1">
                <img class="body_img" src="" alt="" />
                <div class="body_con">
                  <div class="con_title">
                    九阳电饭锅1L3L5L电饭煲小型宿舍家用2人迷你多功能 全自动大容量
                  </div>
                  <div class="con_ge">
                    <i>颜色：棕色</i>
                    <em>规格：1-2人用小饭煲(机械型)</em>
                  </div>
                </div>
              </li>
              <li class="td2">￥798.00</li>
              <li class="td3">×2</li>
              <li class="td4">￥798.00</li>
            </ul>
          </div>
          <div class="pay_total">
            <div class="pay_price">商品总计：￥798.00</div>
            <div class="pay_dicount">使用优惠券：-￥30.00</div>
            <div class="pay_at">
              <div class="pay_side">
                <div class="pay_paid">
                  <i>实付：</i>
                  <em>￥798.00</em>
                </div>
                <div class="pay_comm">共3件商品</div>
              </div>
              <div class="pay_stand">立即支付</div>
            </div>
            <div class="pay_call">取消订单</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumb from '../../components/bread-crumb/Index.vue'
import orderMenu from '../../components/order_menu.vue'
export default {
  name: '产品中心',
  components: {
    crumb,
    orderMenu
  }
}
</script>
<style lang="scss" scoped>
.container {
  width: 1200px;
}
.lg {
  display: flex;
  justify-content: space-between;
  margin: 36px 0 0 0;
  .pay_con {
    width: 880px;
    background: white;
    .pay_total {
      display: flex;
      padding: 24px 30px;
      flex-direction: column;
      align-items: flex-end;
      .pay_call {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        margin: 20px 50px 0 0;
        cursor: pointer;
      }
      .pay_at {
        display: flex;
        .pay_stand {
          width: 164px;
          height: 56px;
          line-height: 56px;
          text-align: center;
          color: white;
          cursor: pointer;
          background: linear-gradient(90deg, #ff5e41 0%, #fc4353 100%);
          border-radius: 8px;
          margin: 0 0 0 16px;
        }
        .pay_side {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          .pay_comm {
            font-size: 14px;
            font-weight: 400;
            color: #3e3a39;
            margin: 8px 0 0 0;
          }
          .pay_paid {
            display: flex;
            align-items: center;
            em {
              font-size: 20px;
              font-weight: bold;
              color: #fc4353;
            }
            i {
              font-size: 14px;
              font-weight: 400;
              color: #3e3a39;
            }
          }
        }
      }
      .pay_price,
      .pay_dicount {
        font-size: 14px;
        font-weight: 400;
        color: #3e3a39;
        margin: 0 0 12px 0;
      }
    }
    .side {
      margin: 30px 30px 0 30px;
      padding: 0 0 20px 0;
      border: 1px solid #eeeeee;
      .pay_body {
        padding: 24px 20px 0 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .td4 {
          flex: 1;
          padding: 0 10px;
          color: #3e3a39;
          text-align: center;
        }
        .td3 {
          flex: 1.2;
          padding: 0 10px;
          color: #3e3a39;
          text-align: center;
        }
        .td2 {
          flex: 1.5;
          padding: 0 10px;
          text-align: center;
          color: #3e3a39;
        }
        .td1 {
          flex: 4.7;
          padding: 0 10px 0 0;
          display: flex;
          .body_con {
            width: 100%;
            .con_ge {
              display: flex;
              font-size: 14px;
              font-weight: 400;
              color: #999999;
              i {
                margin: 0 12px 0 0;
              }
            }
            .con_title {
              font-size: 14px;
              font-weight: 400;
              line-height: 22px;
              color: #3e3a39;
              margin: 0 0 12px 0;
            }
          }
          .body_img {
            width: 80px;
            height: 80px;
            overflow: hidden;
            flex-shrink: 0;
            margin: 0 12px 0 0;
          }
        }
      }
      .collec_text {
        padding: 20px 20px 0 20px;
        display: flex;
        flex-direction: column;
        font-size: 14px;
        font-weight: 400;
        color: #3e3a39;
        li {
          display: flex;
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          align-items: center;
          margin: 0 0 12px 0;
          .red {
            font-size: 14px;
            font-weight: 600;
            color: #fc4353;
          }
          .label {
            padding: 0 12px 0 0;
          }
        }
      }
      .collec_state {
        padding: 14px 20px;
        background: #f5f5f5;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        font-weight: 400;
        color: #3e3a39;
        .pay1 {
          flex: 4;
        }
        .pay2 {
          flex: 1.5;
          text-align: center;
        }
        .pay3 {
          flex: 1.2;
          text-align: center;
        }
        .pay4 {
          flex: 1;
          text-align: center;
        }
        .th1 {
          flex: 1;
          text-align: center;
          &.cen {
            text-align: left;
          }
        }
      }
    }
    .collec_title {
      height: 48px;
      padding: 12px 20px;
      font-size: 18px;
      font-weight: 600;
      color: #3e3a39;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #eeeeee;
      em {
        color: #fc4353;
      }
    }
  }
}
</style>
